/**
 * Static data + shared row types for the Team-Chat module (1:1 with the
 * prototype: channels L450–454, DMs L458–462, `teamMessages` L2674–2680 of
 * Hausverwaltung Hero.dc.html).
 */

import type { Translate } from "@/lib/i18n/translate";

/** A direct-message row in the sidebar (round initials avatar + presence dot). */
export type DmRow = {
  readonly initials: string;
  readonly avBg: string;
  readonly avFg: string;
  readonly statusDot: string;
  readonly name: string;
};

/** DM rows above the active group thread (Tobias, Carla). */
export function dmRowsTop(t: Translate): readonly DmRow[] {
  return [
    {
      initials: "TB",
      avBg: "#2A2F3A",
      avFg: "#fff",
      statusDot: "#C2C7CE",
      name: t("tobiasBerger"),
    },
    {
      initials: "CV",
      avBg: "#EEE9F7",
      avFg: "#6D5BA6",
      statusDot: "#3A9E6B",
      name: t("carlaVogt"),
    },
  ];
}

/** DM rows below the active group thread (Jana, Markus). */
export function dmRowsBottom(t: Translate): readonly DmRow[] {
  return [
    {
      initials: "JP",
      avBg: "#F6E9EE",
      avFg: "#B05B79",
      statusDot: "#E0A500",
      name: t("janaPohl"),
    },
    {
      initials: "MF",
      avBg: "#E7EEF8",
      avFg: "#3F6CB0",
      statusDot: "#C2C7CE",
      name: t("markusFrey"),
    },
  ];
}

/**
 * Sidebar channel handles (rendered with a leading "#").
 * `t` is `useTranslations("marketing.moduleTeamchatData")`.
 */
export function channels(t: Translate): readonly string[] {
  return [
    t("kanalAllgemein"),
    t("kanalInstandhaltung"),
    t("kanalVermietung"),
    t("kanalBuchhaltung"),
    t("kanalEtvOrga"),
  ];
}

/** A thread entry — either a date separator or a chat message. */
export type TeamEntry =
  | { readonly kind: "date"; readonly date: string }
  | {
      readonly kind: "msg";
      readonly author: string;
      readonly time: string;
      readonly avInit: string;
      readonly avBg: string;
      readonly avFg: string;
      readonly statusDot: string;
      readonly text: string;
    };

/** A chat message (the non-date variant of `TeamEntry`). */
export type TeamMessage = Extract<TeamEntry, { readonly kind: "msg" }>;

/** `t` is `useTranslations("marketing.moduleTeamchatData")`. */
export function teamMessages(t: Translate): readonly TeamEntry[] {
  return [
    { kind: "date", date: t("gestern") },
    {
      kind: "msg",
      author: "Carla Vogt",
      time: "16:22",
      avInit: "CV",
      avBg: "#EEE9F7",
      avFg: "#6D5BA6",
      statusDot: "#3A9E6B",
      text: t("nachrichtEigentuemerversammlung"),
    },
    {
      kind: "msg",
      author: "David Lehmann",
      time: "16:35",
      avInit: "DL",
      avBg: "#E7EEF8",
      avFg: "#3F6CB0",
      statusDot: "#3A9E6B",
      text: t("nachrichtEinladungenProtokoll"),
    },
    { kind: "date", date: t("heute") },
    {
      kind: "msg",
      author: "Nina Hartmann",
      time: "09:48",
      avInit: "NH",
      avBg: "#0B0F19",
      avFg: "#ffffff",
      statusDot: "#3A9E6B",
      text: t("nachrichtHausgeldabrechnung"),
    },
  ];
}
